/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Grid, OutlinedInput } from '@mui/material'
import * as React from 'react'
import { IMaskInput } from 'react-imask'
import { Button, DateTimePicker, Text } from 'shared/components'
import { DateRangeQuery } from 'types/common'
import dayjs from 'dayjs'

interface SearchCustomerProps {
  onChangePhoneNumber: (e: React.ChangeEvent<HTMLInputElement>) => void
  onSearch: () => void
  phoneNumber?: string
  disabled?: boolean
  disabledReport?: boolean
  loading?: boolean
  isExporting?: boolean
  onReport: () => void
  onExportAll: () => void
  isExportingAll?: boolean
  onDateRangeChange: (range: DateRangeQuery) => void
  dateRangeValue: DateRangeQuery
  defaultDateRange: DateRangeQuery
}

interface IMaskInputProps {
  onChange: (e: { target: { name: string; value: any } }) => void
  name?: string
}

const PhoneNumber = React.forwardRef<HTMLInputElement, IMaskInputProps>(
  ({ onChange, ...rest }, ref) => {
    const handleChange = (val: any) => {
      onChange({ target: { name: rest.name || '', value: val } })
    }
    return (
      <IMaskInput
        {...rest}
        mask="00000000000"
        onAccept={handleChange}
        unmask="typed"
        overwrite
        inputRef={ref}
      />
    )
  }
)

const SearchCustomer = ({
  dateRangeValue,
  onChangePhoneNumber,
  onReport,
  onSearch,
  disabled = false,
  loading = false,
  disabledReport = true,
  isExporting = false,
  onExportAll,
  isExportingAll = false,
  onDateRangeChange,
  defaultDateRange,
}: SearchCustomerProps) => {
  return (
    <Grid container direction="column" rowGap={3}>
      <Grid item>
        <Grid flexDirection="row" columnGap={2} alignItems="center" container>
          <Grid item>
            <Text width={100}>Số điện thoại </Text>
          </Grid>
          <Grid item>
            <OutlinedInput
              onChange={onChangePhoneNumber}
              inputComponent={PhoneNumber as any}
              sx={{
                height: 40,
                width: 300,
              }}
            />
          </Grid>
          <Grid item>
            <Box gap={2} display="flex" flexDirection="row" alignItems="center">
              <Button
                onClick={onSearch}
                disabled={disabled || loading}
                loading={loading}
                width={100}
              >
                Tìm kiếm
              </Button>
              <Button
                disabled={disabledReport || isExporting}
                loading={isExporting}
                width={140}
                onClick={onReport}
              >
                Xuất report
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container alignItems="flex-end" columnGap={2}>
          <DateTimePicker
            maxDate={dayjs(defaultDateRange.toDate)}
            sx={{
              width: 300,
              '& input': {
                height: 40,
                p: '0px 12px',
              },
            }}
            onChange={d => {
              onDateRangeChange({
                fromDate: d ? d.toISOString() : dateRangeValue.fromDate,
                toDate: dateRangeValue.toDate,
              })
            }}
            defaultValue={dayjs(defaultDateRange.fromDate)}
            label="Từ ngày"
          />
          <DateTimePicker
            label="Đến ngày"
            sx={{
              width: 300,
              '& input': {
                height: 40,
                p: '0px 12px',
              },
            }}
            maxDateTime={dayjs(defaultDateRange.toDate)}
            onChange={d => {
              onDateRangeChange({
                toDate: d ? d.toISOString() : defaultDateRange.toDate,
                fromDate: dateRangeValue.fromDate,
              })
            }}
            defaultValue={dayjs(dateRangeValue.toDate)}
          />
          <Button
            disabled={isExportingAll}
            loading={isExportingAll}
            width={200}
            onClick={onExportAll}
          >
            Xuất tất cả report
          </Button>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default SearchCustomer
